module.exports = __webpack_public_path__ + "assets/d6615781205a72c51d6df573fc8abfdb.mp3";